class DataViewFormatter {
    format = (dataViews) => {
        const formattedDataViews = [];

        if (Array.isArray(dataViews)) {
            dataViews.forEach((d) => {
                let columnInformation =
                    d.dataViewInfo?.tableDisplayInformation
                        ?.columnInformation || [];

                if (d.DataViewType?.toLowerCase() === "leave") {
                    columnInformation = columnInformation.filter(
                        (col) =>
                            ![
                                "intermittentDt",
                                "startTime",
                                "endTime",
                                "intermittentAbsenceDisplayName",
                                "reportedDt",
                            ].includes(col.AccessorKey)
                    );
                }

                const parametersOptions = d?.parametersOptions;
                const parameters = {
                    CoverageType: d.dataViewInfo?.parameters?.coverageTypes,
                    reportingPeriodDateTypeDisability:
                        d.dataViewInfo?.parameters
                            ?.reportingPeriodDateTypeDisability,
                    Status: d.dataViewInfo?.parameters?.statuses,
                    EffectiveStartDate:
                        d.dataViewInfo?.parameters?.effectiveStartDt,
                    EffectiveEndDate:
                        d.dataViewInfo?.parameters?.effectiveEndDt,
                    PeriodScheduleTypes:
                        d.dataViewInfo?.parameters?.periodScheduleTypes,
                    IncludeHistoricalLeave:
                        d.dataViewInfo?.parameters?.includeHistoricalLeave,
                    PolicyAndDivisions:
                        d.dataViewInfo?.parameters?.policyAndDivisions,
                    PaymentStatuses:
                        d.dataViewInfo?.parameters?.paymentStatuses,
                    planRequestStatus:
                        d.dataViewInfo?.parameters?.planRequestStatus,
                    ProductGroupCds:
                        d.dataViewInfo?.parameters?.productGroupCds,
                    ProtectionStatuses:
                        d.dataViewInfo?.parameters?.protectionStatuses,
                    ReportingGroups:
                        d.dataViewInfo?.parameters?.reportingGroups,
                    reportingPeriod:
                        d.dataViewInfo?.parameters?.reportingPeriod,
                    compareYourCompanyTo:
                        d.dataViewInfo?.parameters?.compareYourCompanyTo,
                    reportingPeriodDateType:
                        d?.dataViewInfo?.parameters
                            ?.reportingPeriodDateTypeLeave ||
                        d?.dataViewInfo?.parameters
                            ?.reportingPeriodDateTypeDisability ||
                        d?.dataViewInfo?.parameters
                            ?.reportingPeriodDateTypeAbsence,
                };

                const tableDisplayInformation = {
                    ColumnInformation: columnInformation,
                    SortOrder:
                        d.dataViewInfo?.tableDisplayInformation?.sortOrder,
                    ColumnFilters:
                        d.dataViewInfo?.tableDisplayInformation?.columnFilters,
                };

                const snapshotCustomLabels = d.dataViewInfo?.customLabels || {};

                const reportDetails = {
                    ViewId: d.viewId,
                    DataViewType: d.dataViewType,
                    MostRecentOrder: d.mostRecentOrder,
                    MostUsedOrder: d.mostUsedOrder,
                    Name: d.dataViewInfo?.name,
                    Description: d.dataViewInfo?.description,
                    OwnerType: d.ownerType,
                    Shared: d.shared,
                    SubViewName: d.subViewName,
                    ParametersOptions: parametersOptions,
                    Parameters: parameters,
                    TableDisplayInformation: tableDisplayInformation,
                    SubscriptionInfo: d.subscriptionInfo,
                    SnapshotCustomLabels: snapshotCustomLabels,
                    ExpansionFactor: d.expansionFactor,
                    MaxDisplayRows: d.maxDisplayRows,
                };

                formattedDataViews.push(reportDetails);
            });
        }

        return formattedDataViews;
    };
}

export default new DataViewFormatter();
